import React from 'react';
import { arrayOf, bool, object } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { connect } from 'react-redux';
import { isSingleOrderSelected } from '../../../reducers/checkoutPlan';
import { translateTimeUnit } from '../../../utils/recurring/translation';
import { getRecurringOptions, getSelectedRecurringOption } from '../../../reducers/packages';

import './style.scss';

const RecurringOptionDiscount = ({
    recurringOptions,
    isSingleOrderSelected = false,
    selectedRecurringOption,
    showShortDiscount = false,
    showOnSingleOrder = true
}) => {
    const { duration, durationTimeUnit, discountPercentage } = selectedRecurringOption;

    const isSingleOption = recurringOptions.length === 1;
    const copySuffix = showShortDiscount ? 'short_discount' : 'discount';

    const getDiscountParams = () => ({
        percentage: discountPercentage,
        time_unit: translateTimeUnit(duration, durationTimeUnit)
    });

    const calculateShow = () => {
        const hasDiscount = discountPercentage > 0;

        return isSingleOrderSelected
            ? hasDiscount && showOnSingleOrder
            : hasDiscount;
    };

    const show = calculateShow();

    const wrapperClass = classNames(
        'recurring-option-discount',
        'tbody-6',
        {
            'single-order': isSingleOrderSelected,
            'single-option': isSingleOption
        }
    );

    if (!show) {return null;}

    return (
        <p className={wrapperClass}>
            <I18n k={`gig_page_perseus.recurring.${copySuffix}`}
                params={getDiscountParams()}/>
        </p>
    );
};

RecurringOptionDiscount.propTypes = {
    recurringOptions: arrayOf(object).isRequired,
    isSingleOrderSelected: bool,
    selectedRecurringOption: object.isRequired,
    showShortDiscount: bool,
    showOnSingleOrder: bool
};

const mapStateToProps = (state) => {
    const { packages } = state;
    const recurringOptions = getRecurringOptions(packages);
    const selectedRecurringOption = getSelectedRecurringOption(packages);

    return {
        recurringOptions,
        isSingleOrderSelected: isSingleOrderSelected(state),
        selectedRecurringOption
    };
};

export { RecurringOptionDiscount };
export default connect(mapStateToProps)(RecurringOptionDiscount);
